import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import sessionConstants from "csi/sessionConstants";
import PathMatrix from "csi/table/matrix/Path";

const ProjectLineItemsMatrix = declare(PathMatrix, {
	/**
	 * @override
	 * Filter Project Items for the supplier user
	 */
	_filterNodes: function(ctx, spec, nodes) {
		return _.filter(nodes, (node) => {
			return _.some(node.AssignedSuppliers, (url) => {
				return (url == sessionConstants.userSupplierUrl);
			});
		});
	},
});

export = ProjectLineItemsMatrix;